export default __webpack_public_path__ + "static/media/icon_cancelled.7969b1b8.svg";